import { createContext, Dispatch } from 'react';

import { FormInstance } from 'antd';

import { StepTwoForm } from '../../../../../utils';

interface StepTwoFormContextProps {
  stepTwoForm: FormInstance<StepTwoForm> | undefined;

  dateFrom: string;
  setDateFrom: Dispatch<React.SetStateAction<string>>;

  //* Methods
  getDateFromLifeObligatory: (todayDate: string) => Promise<void>;
}

export const StepTwoFormContext = createContext({} as StepTwoFormContextProps);
